import {shape, bool, oneOf} from 'prop-types';
import CustomerSettings from './CustomerSettings';

export default shape({
  data: shape({
    onDemand: shape({
      wifi: shape({
        enabled: bool
      }),
      workflow: oneOf(['dvr', 'vehicle'])
    }),
    dvrPairing: shape({
      method: oneOf(['dsn', 'vin'])
    }),
    settings: CustomerSettings
  })
});
